import { defineMessages } from "react-intl"

export default defineMessages({
  warningText: {
    id: "app.components.UnsavedWarningModal.warningText",
  },
  confirm: {
    id: "app.components.UnsavedWarningModal.confirm",
  }
})
